<script lang="ts">
    import Description from '@components/description';

    import type { DescriptionDto } from './types';

    let { data }: { data: DescriptionDto } = $props();
</script>

<Description description={data.description} />

<style>
</style>
